import React from 'react'
import {
    CellsTitle, Cells, TextArea, CellBody, Form, FormCell, Button,
    Toast, Dialog, Toptips, Flex, FlexItem, CellHeader, Label, Input
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import Header from '../../components/liveroomLecturer/Header'
import '../../css/page/ChannelLectureEditPage.css'


class ChannelEditRewardPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            rewardConfig: [0, 0, 0, 0, 0, 0],
            rewardPercent: 0,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchData()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/lecture/${this.props.params.id}/edit_info`)
            .then(res => {
                this.setState({
                    rewardConfig: res.data.data.lecture.rewards,
                    rewardPercent: res.data.data.lecture.reward_percent,
                    isPending: false,
                })
            })
    }
    onClickAlertOk () {
        browserHistory.go(-1)
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    onSubmit (e) {
        const verifyRes = this.verify()
        if (!verifyRes.status) {
            return this.showTip(verifyRes.msg)
        }
        this.setState({ isPending: true })
        axios.post(`/api/lecture/${this.props.params.id}/edit`, qs.stringify({
            reward_config: JSON.stringify(this.state.rewardConfig),
            reward_percent: this.state.rewardPercent,
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.setState({
                    alertDialog: { isShow: true, text: '修改成功' }
                })
            })
    }
    verify () {
        if (this.state.rewardConfig.some(item => isNaN(+item) || item === '' || /\./.test(item))) {
            return { status: false, msg: '打赏金额应该是整数' }
        }
        return { status: true }
    }
    onChangeReward (e, index) {
        const value = e.target.value
        // if (isNaN(value)) {
        //     return
        // }
        const rewardConfig = this.state.rewardConfig.slice()
        rewardConfig[index] = value
        this.setState({ rewardConfig })
    }
    renderInputItem (num) {
        return (
            <input type="number" pattern='[0-9]*' onChange={e => this.onChangeReward(e, num)} value={this.state.rewardConfig[num]} />
        )
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-edit-page">
                    <div className="reward-page">
                        <Header title='打赏设置' />
                        <div className="wk-bg-white margin-bottom padding-top-10 wk-border-line-after wk-border-line-before wk-position-rlt">
                            <Flex>
                                <FlexItem>
                                    {this.renderInputItem(0)}
                                </FlexItem>
                                <FlexItem>
                                    {this.renderInputItem(1)}
                                </FlexItem>
                                <FlexItem>
                                    {this.renderInputItem(2)}
                                </FlexItem>
                            </Flex>
                            <Flex>
                                <FlexItem>
                                    {this.renderInputItem(3)}
                                </FlexItem>
                                <FlexItem>
                                    {this.renderInputItem(4)}
                                </FlexItem>
                                <FlexItem>
                                    {this.renderInputItem(5)}
                                </FlexItem>
                            </Flex>
                        </div>
                        <Form className='margin-bottom'>
                            <FormCell>
                                <CellHeader>
                                    <Label>分成比例（%）</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input
                                        onChange={e => this.bindValue(e, 'rewardPercent')}
                                        type="number"
                                        pattern='[0-9]*'
                                        placeholder="请输入分成比例"
                                        value={this.state.rewardPercent}
                                        className='text-right'
                                    />
                                </CellBody>
                            </FormCell>
                        </Form>
                        <p className="intro sm">1. 设置的比例为创建者获得的打赏分成（0~100）</p>
                        <p className="intro sm">2. 课程嘉宾则获得剩余的部分。</p>
                        <p className="intro sm margin-bottom">3. 对于转载课程，创建者是指转载者。</p>
                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit()}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: 'Ok', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default ChannelEditRewardPage



// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditRewardPage.js